import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  const structuredAnswers = {}
  result.map(answer => addAnswerStructuredByChapter(structuredAnswers, answer))
  return {
    ...state,
    answers: structuredAnswers,
    isLoading: false,
  }
}

let addAnswerStructuredByChapter = (structuredAnswers, answer) => {
  if (chapterNotExists(structuredAnswers, answer.kapitelId)) {
    addChapter(structuredAnswers, answer.kapitelId)
  }
  addAnswer(structuredAnswers, answer)
}

let chapterNotExists = (existingAnswers, kapitelId) => !existingAnswers[kapitelId]

let addChapter = (existingAnswers, kapitelId) => {
  existingAnswers[kapitelId] = {}
}

let addAnswer = (existingAnswers, answer) => {
  existingAnswers[answer.kapitelId][answer.frageId] = answer
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action(payload) {
  try {
    return await Api.getAnswersAsAusbilder(payload.azubiId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
